<!-- Full page wrapper -->
<div class="min-h-screen bg-slate-50 flex justify-center sm:pb-20">
  <div
    class="w-full max-w-md bg-white min-h-screen sm:min-h-[calc(100vh-2rem)] sm:mt-8 sm:rounded-3xl sm:shadow-2xl sm:border border-slate-200 overflow-hidden relative flex flex-col">

    <!-- Header background decor -->
    <div
      class="absolute top-0 inset-x-0 h-64 bg-gradient-to-br from-blue-50 via-indigo-50/50 to-white -z-10 rounded-b-[3rem]">
    </div>

    <!-- Header -->
    <div class="sticky top-0 z-20 bg-white/60 backdrop-blur-xl shadow-sm border-b border-white/40">
      <div class="flex items-center justify-between gap-3 px-5 py-4">
        <h2 class="text-[15px] font-bold text-slate-800 tracking-tight">
          {{ 'เข้าสู่ระบบ / สร้างบัญชี' | translate : 'confirm-email' }}
        </h2>
        <app-language-switcher />
      </div>
    </div>

    <!-- Content -->
    <div class="flex-1 overflow-y-auto w-full px-5 pt-8 pb-10">

      <!-- Icon & Title -->
      <div class="text-center mb-8">
        @if (theme.logoUrl(); as logo) {
        <div
          class="inline-flex items-center justify-center w-20 h-20 rounded-[1.5rem] bg-white shadow-lg shadow-blue-500/30 mb-5 overflow-hidden border border-slate-100">
          <img [src]="logo" [alt]="theme.name()" class="w-full h-full object-contain" />
        </div>
        } @else {
        <div
          class="inline-flex items-center justify-center w-20 h-20 rounded-[1.5rem] bg-gradient-to-br from-blue-600 to-indigo-600 shadow-lg shadow-blue-500/30 mb-5 relative overflow-hidden group">
          <div class="absolute inset-0 bg-white/20 blur-xl group-hover:bg-white/30 transition-colors"></div>
          <span class="material-symbols-outlined text-white relative z-10" style="font-size: 2.5rem;">hotel</span>
        </div>
        }
        <h1 class="text-3xl font-black text-slate-900 tracking-tight">{{ 'ยินดีต้อนรับ' | translate : 'confirm-email' }}</h1>
        @if (theme.name()) {
        <p class="mt-1 text-base font-bold text-blue-600">{{ theme.name() }}</p>
        }
        <p class="mt-2 text-sm font-medium text-slate-500">{{ 'เข้าสู่ระบบหรือสร้างบัญชีเพื่อเริ่มการจอง' | translate : 'confirm-email' }}</p>
      </div>

      <!-- Card -->
      <div class="bg-white rounded-3xl shadow-[0_8px_30px_rgba(0,0,0,0.06)] border border-slate-100/60 overflow-hidden">

        <!-- Card Header -->
        <div class="bg-gradient-to-r from-blue-600 to-indigo-600 px-6 py-5 relative overflow-hidden">
          <div class="absolute -right-4 -top-4 w-24 h-24 bg-white/10 rounded-full blur-xl"></div>
          <p class="text-white font-bold text-[15px] relative z-10">{{ 'เข้าสู่ระบบด้วยอีเมล' | translate : 'confirm-email' }}</p>
          <p class="text-blue-100 text-xs font-medium mt-1 relative z-10">{{ 'ระบุอีเมลเพื่อรับรหัส OTP' | translate : 'confirm-email' }}</p>
        </div>

        <!-- Card Body -->
        <div class="p-6">
          <label class="block text-[11px] font-bold text-slate-500 uppercase tracking-wider mb-2">
            {{ 'อีเมล' | translate : 'confirm-email' }} <span class="text-red-500">*</span>
          </label>

          <div class="relative group">
            <span class="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 transition-colors"
              [class]="emailError ? 'text-red-400' : 'text-slate-400 group-focus-within:text-blue-600'"
              style="font-size: 1.25rem;">
              mail
            </span>
            <input type="email" inputmode="email" autocomplete="email" [placeholder]="'กรอกอีเมลของท่าน' | translate : 'confirm-email'"
              [(ngModel)]="form.email" (input)="submitted = false"
              [class]="emailError
                ? 'w-full rounded-2xl border bg-white py-3.5 pl-12 pr-10 text-[15px] font-bold text-slate-800 placeholder:text-slate-400 placeholder:font-normal outline-none border-red-400 ring-4 ring-red-400/10 transition-all'
                : 'w-full rounded-2xl border border-slate-200 bg-slate-50 py-3.5 pl-12 pr-10 text-[15px] font-bold text-slate-800 placeholder:text-slate-400 placeholder:font-normal focus:border-blue-500 focus:bg-white focus:outline-none focus:ring-4 focus:ring-blue-500/10 transition-all'" />
            @if(emailError) {
            <span
              class="material-symbols-outlined absolute right-4 top-1/2 -translate-y-1/2 text-red-500 bg-red-50 rounded-full p-0.5"
              style="font-size: 1rem;">
              error
            </span>
            }
          </div>

          @if(emailError) {
          <div
            class="mt-3 flex items-start gap-1.5 text-xs text-red-600 bg-red-50 p-2.5 rounded-xl border border-red-100">
            <span class="material-symbols-outlined shrink-0 mt-0.5" style="font-size: 1rem;">info</span>
            <span class="leading-relaxed font-medium">{{ emailError }}</span>
          </div>
          }

          <button type="button" (click)="sendEmail()"
            class="mt-6 w-full rounded-2xl bg-slate-900 py-4 text-[15px] font-bold text-white
                   hover:bg-black active:scale-[0.98] transition-all shadow-lg shadow-black/10 flex items-center justify-center gap-2">
            {{ 'ดำเนินการต่อ' | translate : 'confirm-email' }}
            <span class="material-symbols-outlined text-[18px]">arrow_forward</span>
          </button>

          <button type="button" (click)="cancel()"
            class="mt-3 w-full rounded-2xl border border-slate-200 bg-white py-4 text-[15px] font-bold text-slate-600
                   hover:bg-slate-50 active:scale-[0.98] transition-all flex items-center justify-center gap-2">
            <span class="material-symbols-outlined text-[18px]">arrow_back</span>
            {{ 'ยกเลิก' | translate : 'confirm-email' }}
          </button>

          <!-- Divider -->
          <div class="mt-6 flex items-center gap-3">
            <div class="flex-1 h-px bg-slate-100"></div>
            <span
              class="text-[10px] font-bold text-slate-400 uppercase tracking-widest bg-white px-2">{{ 'ปลอดภัยและเป็นส่วนตัว' | translate : 'confirm-email' }}</span>
            <div class="flex-1 h-px bg-slate-100"></div>
          </div>

          <!-- Trust badges -->
          <div
            class="mt-5 flex items-center justify-center gap-4 text-[11px] font-bold text-slate-500 bg-slate-50 py-3 rounded-2xl">
            <div class="flex flex-col items-center gap-1 w-20">
              <div class="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center text-green-600 mb-1">
                <span class="material-symbols-outlined" style="font-size: 1.1rem;">verified_user</span>
              </div>
              <span class="text-center">{{ 'ปลอดภัย' | translate : 'confirm-email' }}</span>
            </div>
            <div class="flex flex-col items-center gap-1 w-20">
              <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mb-1">
                <span class="material-symbols-outlined" style="font-size: 1.1rem;">lock</span>
              </div>
              <span class="text-center">{{ 'เข้ารหัส' | translate : 'confirm-email' }}<br>{{ 'ข้อมูล' | translate : 'confirm-email' }}</span>
            </div>
            <div class="flex flex-col items-center gap-1 w-20">
              <div class="w-8 h-8 rounded-full bg-purple-100 flex items-center justify-center text-purple-600 mb-1">
                <span class="material-symbols-outlined" style="font-size: 1.1rem;">privacy_tip</span>
              </div>
              <span class="text-center">{{ 'ไม่แชร์' | translate : 'confirm-email' }}<br>{{ 'ข้อมูล' | translate : 'confirm-email' }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer note -->
      <p class="text-center text-[11px] text-slate-400 mt-8 px-4 leading-relaxed font-medium">
        {{ 'การใช้งานต่อไปถือว่าท่านยอมรับ' | translate : 'confirm-email' }}<br>
        <span class="text-blue-600 font-bold hover:underline cursor-pointer">{{ 'นโยบายความเป็นส่วนตัว' | translate : 'confirm-email' }}</span>
        {{ 'และ' | translate : 'confirm-email' }}
        <span class="text-blue-600 font-bold hover:underline cursor-pointer">{{ 'เงื่อนไขการใช้งาน' | translate : 'confirm-email' }}</span>
      </p>

    </div>
  </div>
</div>